import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core'
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'

@Component({
    template: require('./confirmation-dialog.component.html')
})
export class ConfirmationDialogComponent implements OnInit {
    onSuccess = new EventEmitter();
    title: string = "Confirmation";
    showCloseButton: boolean = true;

    constructor(private dialog: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public model: any) {
        this.title = (model.title == undefined || model.title == null || model.title == "") ? this.title : model.title;
        this.showCloseButton = (model.showCloseButton == undefined || model.showCloseButton == null || typeof (model.showCloseButton) != "boolean") ? this.showCloseButton : model.showCloseButton;
    }

    ngOnInit() {
    }

    actionOne() {
        this.onSuccess.emit(true);
    }

    actionTwo() {
        this.onSuccess.emit(false);
    }

    actionThree() {
        this.dialog.close();
    }
}
